<template>
  <CRow id="iframe">
    <p>Link to sheet: <a :href="url" target="_new">link</a></p>

  </CRow>
</template>

<script>

export default {
  name: 'Sheet',
  data () {
    return {
      url: ''
    }
  },
  watch: {

  },
  methods: {
    
  },
  props: ['sheet_id'],
  mounted () {
      if(this.$route.query.sheet_id) {
        this.sheet_id = this.$route.query.sheet_id;
      }

      this.url = 'https://docs.google.com/spreadsheets/d/'+this.sheet_id+'/edit';

      var element = document.getElementById("iframe");
      var iframe = document.createElement('iframe');
      iframe.src = 'https://docs.google.com/spreadsheets/d/'+this.sheet_id+'/edit';
      iframe.width = '100%';
      iframe.height = '800px';

      element.appendChild(iframe);

      console.log('loaded iframe ', this.sheet_id);
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 800px;
}
</style>
